import React from 'react';

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareArrowLeft } from "@fortawesome/pro-light-svg-icons";

import OrganizationLogoNav from '../protected/OrganizationLogoNav';
import UserNav from '../../components/UserNav';
import BookmarkButton from './components/bookmark/BookmarkButton';
import ProposalButton from './components/proposal/ProposalButton';
import ScannerButton from "./components/scanner/ScannerButton";
import CustomerButton from "../../components/customer/CustomerButton";

import "./OrganizationLogoHeader.scss";
import { SidebarContentType, useSidebarContext } from "../../hooks/useSidebarContext";

export default function OrganizationLogoHeader({
	currentUserInfo,
}) {

	const branding = currentUserInfo?.organization?.branding;
	const hasBranding = !!branding?.themes?.header;

	const SidebarContext = useSidebarContext();

	React.useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams?.has("demo")) {
			urlParams.get("demo")?.toLowerCase() === "true"
				? localStorage.setItem("inDemoMode", "true")
				: localStorage.removeItem("inDemoMode");
		}
	}, []);
	const isInDemoMode = localStorage.getItem("inDemoMode") === "true";

	return (
		<div
			data-component="OrganizationLogoHeader"
			className={[
				"user-brand-logo-container",
				hasBranding && 'has-branding',
				isInDemoMode && "demo-mode",
			].filter(v => v).join(" ")}
		>
			<OverlayTrigger
				delay={{ show: 200 }}
				placement="bottom"
				overlay={<Tooltip
					className="_boss tooltip-info">
					Catalog Selection
				</Tooltip>}
			>
				<a href="/catalog/select" className="user-brand-back-container">
					<FontAwesomeIcon
						className="user-brand-logo-back-button"
						icon={faSquareArrowLeft}
					/>
				</a>

			</OverlayTrigger>

			<OrganizationLogoNav />
			<div className="user-brand-nav-items">
				<ScannerButton />
				<CustomerButton />
				{/* <ChatButton
					onClick={() => toggleSidebar("chat")}
				/> */}
				<BookmarkButton
					onClick={() => SidebarContext.open(SidebarContentType.Bookmark)}
				/>
				<ProposalButton
					onClick={() => SidebarContext.open(SidebarContentType.Proposal)}
				/>
				<UserNav />
			</div>

		</div>
	)
}